import { PLPGroupedFacetValue } from 'common/types/plp-data';
import React from 'react';
import styled from 'styled-components';
import CheckboxGroup from '../CheckboxGroup';
import Fieldset from '../Fieldset';

type FacetItem = {
  label: string;
  value: string;
  name: string;
  count: number;
  dataTestId?: string;
  isDisabled?: boolean;
  status: string;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  analyticsId?: string;
  groupID?: string;
};
export type FacetBrandItem = {
  group: string;
  items: FacetItem[];
};

type CheckboxGroupBrandProps = {
  groupDescription: string;
  groups: PLPGroupedFacetValue[];
  dataTestId?: string;
  onChange: (event: React.FormEvent<HTMLElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
  groupID?: string;
};

const BrandGroupStyled = styled.div`
  margin-bottom: var(--spacing-space24);

  &:last-child {
    margin-bottom: 0;
  }
`;

const GroupStyled = styled.div`
  && {
    background: var(--color-global-grey100);
    border-bottom: 1px solid var(--color-global-grey400);
    margin-bottom: var(--spacing-space24);
    padding: var(--spacing-space8) var(--spacing-space16);
    font-weight: var(--font-weight-heading);
    font-size: var(--font-size-2);
    color: var(--color-font-heading);
  }
`;

export function BrandFacetGroup({
  dataTestId: groupTestId,
  groupDescription,
  groups,
  onChange,
  onKeyDown,
  groupID,
}: CheckboxGroupBrandProps) {
  return (
    <Fieldset
      key={groupDescription}
      className="fuse-checkbox-group fuse-checkbox-group--brand"
      dataTestId={groupTestId}
      legend={groupDescription}
    >
      {groups.map(({ group, items }, idx) => (
        <BrandGroupStyled key={`${group}-${idx}`}>
          <GroupStyled>{group}</GroupStyled>

          <CheckboxGroup
            groupDescription={`List of filters ${group}`}
            items={items}
            isFullWidth
            onChange={onChange}
            onKeyDown={onKeyDown}
            groupID={groupID}
          />
        </BrandGroupStyled>
      ))}
    </Fieldset>
  );
}
